export * from './welcome.component';
export * from './profile.component';

export * from './base-crud.component'; //Base
export * from './versions-crud/versions-crud.component';
export * from './actions-crud/actions-crud.component';
export * from './roles-crud/roles-crud.component';
export * from './users-crud/users-crud.component';
export * from './permissions-crud/permissions-crud.component';

export * from './authorities-crud/authorities-crud.component';
export * from './persons-crud/persons-crud.component';
export * from './vehicles-types-crud/vehicles-types-crud.component';
export * from './vehicles-status-crud/vehicles-status-crud.component';
export * from './deposits-crud/deposits-crud.component';
export * from './vehicles-crud/vehicles-crud.component';
export * from './cranes-crud/cranes-crud.component';
export * from './persons-operators-crud/persons-operators-crud.component';
export * from './services-crud/services-crud.component';
export * from './payments-types-crud/payments-types-crud.component';
export * from './services-status-crud/services-status-crud.component';
export * from './expenses-types-crud/expenses-types-crud.component';
export * from './expenses-crud/expenses-crud.component';
export * from './customers-crud/customers-crud.component';
export * from './credits-crud/credits-crud.component';
export * from './accounts-crud/accounts-crud.component';
export * from './receipts-crud/receipts-crud.component';